import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperStyles = ({ theme }) => css`
  label: shipment;

  margin-bottom: ${theme.spacings.kilo};
`

const linkStyles = ({ theme }) => css`
  label: shipment__link;

  color: ${theme.colors.p500};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

const lockerPinWrapperStyles = ({ theme }) => css`
  label: locker-pin-wrapper;

  margin-bottom: ${theme.spacings.mega};
`

export const Wrapper = styled('div')(wrapperStyles)
export const Link = styled('a')(linkStyles)
export const CustomLink = styled('span')(linkStyles)
export const LockerPinWrapper = styled('div')(lockerPinWrapperStyles)
